import { useState, useEffect } from 'react';

/**
 * Small, dependency-free hook to match a media query.
 * Returns true when the media query matches.
 */
export default function useMatchMedia(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia === 'undefined') return;
    const mq = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);

    // Add listener with cross-browser support
    if (mq.addEventListener) mq.addEventListener('change', handler);
    else mq.addListener(handler);

    // Set initial state
    setMatches(mq.matches);

    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', handler);
      else mq.removeListener(handler);
    };
  }, [query]);

  return matches;
}
